module.exports = __webpack_public_path__ + "static/media/wand_ping_001_12529.273320c3.mp3";